var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "#00FF1A",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_746_6818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0714 7.25C10.7979 7.25 7.32141 10.7265 7.32141 15C7.32141 19.2735 10.7979 22.75 15.0714 22.75C19.3449 22.75 22.8214 19.2735 22.8214 15C22.8214 10.7265 19.3449 7.25 15.0714 7.25ZM15.0714 21.25C11.6249 21.25 8.82141 18.4465 8.82141 15C8.82141 11.5535 11.6249 8.75 15.0714 8.75C18.5179 8.75 21.3214 11.5535 21.3214 15C21.3214 18.4465 18.5179 21.25 15.0714 21.25Z",
    fill: "#31C242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0714 12.5491C14.8725 12.5491 14.6817 12.6281 14.5411 12.7688C14.4004 12.9094 14.3214 13.1002 14.3214 13.2991V18.8361C14.3214 19.035 14.4004 19.2258 14.5411 19.3664C14.6817 19.5071 14.8725 19.5861 15.0714 19.5861C15.2703 19.5861 15.4611 19.5071 15.6017 19.3664C15.7424 19.2258 15.8214 19.035 15.8214 18.8361V13.2991C15.8214 13.1002 15.7424 12.9094 15.6017 12.7688C15.4611 12.6281 15.2703 12.5491 15.0714 12.5491ZM15.0714 10.4121C14.8725 10.4121 14.6817 10.4911 14.5411 10.6318C14.4004 10.7724 14.3214 10.9632 14.3214 11.1621V11.1646C14.3214 11.5786 14.6569 11.9136 15.0714 11.9136C15.2672 11.9086 15.4532 11.8272 15.5899 11.687C15.7265 11.5468 15.803 11.3587 15.803 11.1629C15.803 10.967 15.7265 10.779 15.5899 10.6387C15.4532 10.4985 15.2672 10.4172 15.0714 10.4121Z",
    fill: "#31C242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_746_6818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7.07141 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInform);
export default __webpack_public_path__ + "static/media/inform.07b6e0c9451186f80be98f6e996fdfed.svg";
export { ForwardRef as ReactComponent };